import { gql } from "gql";

export const COMPLETE_TIPS = gql(/* GraphQL */ `
  mutation completeTip($tipKey: String!, $value: String!) {
    completeTip(tipKey: $tipKey, value: $value)
  }
`);
